import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

class Icon extends React.Component {
  static propTypes = {
    name: PropTypes.string
  };

  render () {
    const { name, className, ...rest } = this.props
    let iconClass = name.startsWith('bx') ? name : `bx-${name}`
    return (
      <i className={classnames('bx', iconClass, className)} {...rest} />
    )
  }
}

export default Icon

export {
  Icon
}



// WEBPACK FOOTER //
// ./src/components/Icon.js